export default {
  namespaced: true,
  state: () => {
    return {
      isMobilePortraitDevice: false,
    };
  },
  getters: {
    IS_MOBILE_PORTRAIT_DEVICE: (state) => state.isMobilePortraitDevice,
  },
  mutations: {
    SET_MOBILE_PORTRAIT_DEVICE: (state, payload) => (state.isMobilePortraitDevice = payload),
  },
};
